import { LoginPageTranslations } from "./types";

export const enTranslations: LoginPageTranslations = {
    title: "Admin log in only",
    labels: {
        email: "Email",
        password: "Password",
        loginButton: "Login",
    },
    heading: "Login",
    maintenanceClosed:
        "The site is closed for scheduled maintenance. Your password is not the problem — please try again later.",
    chooseRole: {
        title: "Choose a role",
        subtitle:
            "You are an admin in more than one place. Pick one to continue.",
    },
};
